import { render, staticRenderFns } from "./person.vue?vue&type=template&id=22fcbd8d&scoped=true&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "./person.vue?vue&type=style&index=0&lang=less&"
import style1 from "./person.vue?vue&type=style&index=1&id=22fcbd8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcbd8d",
  null
  
)

export default component.exports